<template>
    <div>
        <Hinter :steps="[
            { text: 'Mínimo 6 caracteres', checked: password.length >= 6 },
            { text: 'Campos devem ser iguais', checked: password.length && passwordMirror == password },
        ]"/>
        <vs-input v-validate="{required : true}" name="Nova senha" class="w-full" icon-pack="feather" icon="icon-shield" icon-no-border label="Definir senha" placeholder="" type="password" v-model="password"></vs-input>
        <vs-input v-validate="{required : true}" name="Confirme a senha" class="w-full mt-2" icon-pack="feather" icon="icon-shield" icon-no-border label="Confirme a senha" placeholder="" type="password" v-model="passwordMirror"></vs-input>
    </div>
</template>

<script>
    import Hinter from '../../../../components/Hinter.vue';

    export default {
        components: { Hinter },
        props: {
            propName: Number,
            value: String
        },
        watch: {
            valid (val) {
                this.$emit('valid', val);
            },
            password (val) {
                this.$emit('changed', val);
            }
        },
        data() {
            return {
                password: '',
                passwordMirror: null
            }
        },
        computed: {
            valid () {
                return this.password.length >= 6 && this.passwordMirror === this.password;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>